import { Link } from 'react-router-dom'

import { AuthScreenLayout } from '../components/auth/AuthScreenLayout'
import { NOTIFICATIONS_CONSENT_DOCUMENT_VERSION } from '../legal/notificationsConsent'
import { PERSONAL_DATA_CONSENT_OPERATOR } from '../legal/personalDataConsent'

const op = PERSONAL_DATA_CONSENT_OPERATOR

export const NotificationsConsentLegalScreen = () => (
  <AuthScreenLayout variant="register">
    <article className="market-auth__card market-auth__card--register market-legal-doc">
      <header className="market-auth__card-header market-auth__card-header--compact">
        <h1 className="market-auth__card-title market-auth__card-title--compact">
          Согласие на информационные сообщения
        </h1>
        <p className="market-auth__card-lead market-auth__card-lead--compact">
          Версия {NOTIFICATIONS_CONSENT_DOCUMENT_VERSION}
        </p>
      </header>

      <div className="market-legal-doc__body">
        <p>
          Исполнитель: {op.legalName} ({op.shortName}), ИНН {op.inn}. Платформа: Провизиум
          (market.provisium.ru). Контакт:{' '}
          <a href={`mailto:${op.privacyEmail}`}>{op.privacyEmail}</a>.
        </p>

        <h2>1. Предмет согласия</h2>
        <p>
          Организация даёт согласие на <strong>сервисные</strong> сообщения о работе кабинета, в том
          числе:
        </p>
        <ul>
          <li>создание, изменение и закрытие заявок;</li>
          <li>статусы заявок и ответов поставщиков;</li>
          <li>уведомления о заказах и этапах исполнения;</li>
          <li>служебные сообщения, необходимые для использования кабинета.</li>
        </ul>
        <p>
          <strong>Не входит</strong> в это согласие: рекламные рассылки — для них нужно отдельное
          согласие.
        </p>

        <h2>2. Каналы доставки</h2>
        <ul>
          <li>корпоративная почта, указанная при регистрации или в настройках;</li>
          <li>мессенджеры (Telegram и другие подключённые каналы организации).</li>
        </ul>

        <h2>3. Условия</h2>
        <p>
          Согласие добровольное: регистрация от этого чекбокса не зависит. Чекбокс по умолчанию не
          установлен.
        </p>

        <h2>4. Отзыв согласия</h2>
        <p>
          Отозвать согласие можно запросом на{' '}
          <a href={`mailto:${op.privacyEmail}`}>{op.privacyEmail}</a> с темой «Отзыв согласия на
          уведомления» либо через настройки кабинета, когда раздел уведомлений будет доступен.
        </p>

        <h2>5. Доказательства</h2>
        <p>
          Исполнитель сохраняет факт согласия или отказа, дату и время, версию документа и источник
          (форма регистрации).
        </p>
      </div>

      <p className="market-legal-doc__back">
        <Link className="market-auth__signup-link" to="/register">
          ← Вернуться к регистрации
        </Link>
      </p>
    </article>
  </AuthScreenLayout>
)
